import React from 'react';
import ResourceCard from './ResourceCard';

export default function ResourceList({resources, expandedId, onToggleExpand, onEdit, onDelete, onViewManagers, getManagerEntry, getManagerEntries, managersLoading, isAddEnabled, isAdmin, copyId, copyJSON, formatRoleLabel, isMine}) {
  // Defensive runtime check: ensure ResourceCard is a valid component
  if (!ResourceCard || (typeof ResourceCard !== 'function' && typeof ResourceCard !== 'object')) {
    console.error('ResourceCard component is undefined or invalid:', ResourceCard);
    return (
      <div className="p-6 text-sm text-red-600">
        Resource list component failed to load child component ResourceCard. Check the import/export for ./ResourceCard.js and ensure it has a default export.
      </div>
    );
  }

  if (!resources || resources.length === 0) {
    return (
      <div className="py-12 text-center">
        <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
        </svg>
        <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-gray-100">No resources found</h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Try adjusting your filter or create a new resource.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4 flex-1">
      {resources.map(r => (
        <ResourceCard
          key={r.id}
          resource={r}
          isExpanded={expandedId === r.id}
          onToggleExpand={() => onToggleExpand(r.id)}
          onEdit={onEdit}
          onDelete={onDelete}
          onViewManagers={onViewManagers}
          getManagerEntry={getManagerEntry}
          getManagerEntries={getManagerEntries}
          managersLoading={managersLoading}
          isAddEnabled={isAddEnabled}
          isAdmin={isAdmin}
          copyId={copyId}
          copyJSON={copyJSON}
          formatRoleLabel={formatRoleLabel}
          isOwned={typeof isMine === 'function' ? isMine(r) : false}
        />
      ))}
    </div>
  );
}
